








































































































import Vue from "vue";
import * as types from "./store/types";
import { mapGetters, mapActions } from "vuex";

export default Vue.extend({
  name: "App",

  data: () => ({
    drawer: null,
    menuItems: [
      {
        title: "About",
        to: "/",
      },
      // {
      //   title: "My Application(s)",
      //   to: "/my-account",
      //   when: "loggedIn",
      // },
      // {
      //   title: "Help",
      //   to: "/help",
      // },
      {
        title: "My Account",
        to: "/my-account",
        when: "loggedIn",
      },
      {
        title: "Register",
        to: "/register",
        when: "loggedOut",
      },
      {
        title: "Sign In",
        to: "/sign-in",
        when: "loggedOut",
      },
      {
        title: "Sign Out",
        to: "/sign-out",
        when: "loggedIn",
      },
    ],
  }),

  methods: {
    ...mapActions({
      setServerError: types.SET_SERVER_ERROR,
      getCurrentUser: types.GET_CURRENT_USER,
      setShowTranslate: types.SET_SHOW_TRANSLATE,
    }),
    hideServerErrorDialog() {
      this.setServerError(false);
    },
    resetTranslation() {
      const el = document.querySelector(
        "#app > div.v-dialog__content.v-dialog__content--active > div > div > div.v-card__text > div > div.vg-body > div:nth-child(16) > a"
      );

      // @ts-ignore
      if (el) el.click();
    },
  },

  mounted() {
    // make sure we're still logged in as far as the server is concerned
    if (this.isLoggedIn) this.getCurrentUser();
  },

  computed: {
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN,
      haveServerError: types.SERVER_ERROR,
      showTranslate: types.SHOW_TRANSLATE,
    }),
    activeMenuItems(): {
      title: string;
      to: string;
      when?: string;
    }[] {
      return this.menuItems.filter(
        (item) =>
          !item.when ||
          (item.when == "loggedIn" && this.isLoggedIn) ||
          (item.when == "loggedOut" && !this.isLoggedIn)
      );
    },
  },
});
